import React from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as fromActions from '../actions'
const WeeklyReportForm = ({ createWeeklyReport, patient }) => {
  const onSubmit = e => {
    e.preventDefault()
    const { elements } = e.currentTarget
    const content = elements.namedItem('content').value
    createWeeklyReport({ review: content, patient })
  }
  return (
    <form onSubmit={onSubmit}>
      <textarea name="content" id="content" cols="30" rows="10" />
      <FormattedMessage id="save">
        {label => <button>{label}</button>}
      </FormattedMessage>
    </form>
  )
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      createWeeklyReport: fromActions.createWeeklyReport
    },
    dispatch
  )

export default connect(null, mapDispatchToProps)(WeeklyReportForm)



// WEBPACK FOOTER //
// ./src/Documents/containers/WeeklyReportForm.js